



















import { Component, Vue } from 'vue-property-decorator';
import VesselCard from '@/components/Vessels/VesselCard.vue';
import { Vessel } from '@/types/entities/Vessel';
import { SearchResultItem } from '@/types/SearchResultItem';
import { GET_FAVORITES_VESSELS, SEARCH_VESSELS, SET_VESSEL_FILTER } from '@/store/vessels';

@Component({
  components: { VesselCard }
})
export default class Bookmarks extends Vue {
  get vessels(): Array<SearchResultItem<Vessel>> {
    return this.$store.getters[GET_FAVORITES_VESSELS];
  }

  public beforeRouteEnter(_: any, __: any, next: any) {
    next((vm: Bookmarks) => {
      vm.$store.commit(SET_VESSEL_FILTER, { seller_id: null });
      vm.$store.dispatch(SEARCH_VESSELS);
    });
  }
}
